var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.97998C12.213 7.97998 8.777 9.02598 6.23 10.79C3.684 12.551 2 15.1 2 17.98C2 18.2452 2.10536 18.4996 2.29289 18.6871C2.48043 18.8746 2.73478 18.98 3 18.98C3.26522 18.98 3.51957 18.8746 3.70711 18.6871C3.89464 18.4996 4 18.2452 4 17.98C4 15.875 5.216 13.924 7.37 12.434C9.521 10.943 12.584 9.97998 16 9.97998C19.415 9.97998 22.48 10.943 24.633 12.434C26.786 13.924 28 15.875 28 17.98C28 18.2452 28.1054 18.4996 28.2929 18.6871C28.4804 18.8746 28.7348 18.98 29 18.98C29.2652 18.98 29.5196 18.8746 29.7071 18.6871C29.8946 18.4996 30 18.2452 30 17.98C30 15.1 28.318 12.552 25.771 10.79C23.225 9.02498 19.787 7.97998 16 7.97998Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.98C13.25 13.98 11 16.23 11 18.98C11 21.73 13.25 23.98 16 23.98C18.75 23.98 21 21.73 21 18.98C21 16.23 18.75 13.98 16 13.98ZM16 15.98C17.669 15.98 19 17.312 19 18.98C19 20.65 17.669 21.98 16 21.98C14.331 21.98 13 20.65 13 18.98C13 17.312 14.331 15.98 16 15.98Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewQuery);
export default __webpack_public_path__ + "static/media/view-query.19a54ba3a1002366208fcabacd264738.svg";
export { ForwardRef as ReactComponent };